<template>
    <div class="container">

        <header class="container__header">

            <h1 v-if="isCreating">Tilføj ny kupon</h1>
            <h1 v-else>Rediger kupon</h1>

        </header>

        <div class="container__body container__body--xsm">

            <form class="col-12" @submit.prevent="submitCoupon">

                <div class="col-12 margin-b-75">

                    <label>Kuponens titel</label>

                    <input class="col-12" type="text" name="title" placeholder="Hvad er navnet på kuponen?" minlength="4" maxlength="120" required v-model="coupon.title">

                </div>

                <div class="col-12 margin-b-75">

                    <label>Kuponens kode <template v-if="couponCodeAlreadyUsed"> - Bemærk: denne kode er allerede brugt!</template></label>

                    <input class="col-12" type="text" name="code" placeholder="Hvad er kuponens kode?" minlength="4" maxlength="120" required v-model="codeFormatted" @blur="formatCode">

                </div>

                <div class="col-12 margin-b-75">

                    <label>Kuponens type</label>

                    <label> <input type="radio" :value="true" name="in_percent" v-model="coupon.in_percent" @click="formatPercent"> Procent</label>
                    <!--<label> <input type="radio" :value="false" name="in_percent" v-model="coupon.in_percent"> Beløb</label>-->

                </div>

                <div class="col-12 margin-b-75">

                    <label>Kuponens værdi</label>

                    <input class="col-12" type="tel" name="value" placeholder="Hvad er kuponens værdi?" max="100" required v-model="valuePercentFormatted" @blur="formatPercent" @focus="formatPercent" v-if="coupon.in_percent">
                    <!--<input class="col-12" type="tel" name="value" placeholder="Hvad er kuponens værdi?" required v-model="valueMoneyFormatted" v-else>-->

                </div>

                <div class="col-12 data-list margin-b-75" v-if="products">

                    <h2>Produkter - Mad ud af huset</h2>

                    <div class="item" v-for="product in productsFiltered">

                        <div class="icon">

                            <input class="icon--lg" type="checkbox" :checked="coupon.products.regular.includes(product.id)" @click="checkProduct(product)">

                        </div>

                        <div class="content">

                            <h1 v-text="product.title"></h1>

                        </div>

                        <div class="link">

                        </div>

                    </div>

                </div>

                <div class="col-12 data-list margin-b-75" v-if="customProducts">

                    <h2>Produkter - Nytårsmenu</h2>

                    <div class="item" v-for="product in customProductsFiltered">

                        <div class="icon">

                            <input class="icon--lg" type="checkbox" :checked="coupon.products.custom.includes(product.id)" @click="checkCustomProduct(product)">

                        </div>

                        <div class="content">

                            <h1 v-text="product.title"></h1>

                        </div>

                        <div class="link">

                        </div>

                    </div>

                </div>


                <div class="col-12 margin-t-75">

                    <button type="submit" class="btn btn--md btn--primary primary--copper" :disabled="!validateForm || isSaving">

                        <span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

                        <span v-else>Gem kupon</span>

                    </button>

                </div>

            </form>

        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        name: "create-coupon",
        data(){
            return {
                coupon: {
                    title: '',
                    code: '',
                    in_percent: true,
                    value: 0,
                    products: {
                        regular: [],
                        custom: [],
                    }
                },
                isSaving:false,
            };
        },
        computed:{
            ...mapGetters(['products', 'customProducts', 'coupons']),
            isCreating() {
                return this.$route.params.coupon == null;
            },
            valuePercentFormatted:{
                get(){
                    return this.coupon.value;
                },
                set(value){
                    this.coupon.value = value;
                    this.formatPercent();
                }
            },
            valueMoneyFormatted:{
                get(){
                    return this.stripeAmount(this.coupon.value).amountForEditing;
                },
                set(value){
                    this.coupon.value = this.amountToStripe(value);
                }
            },
            codeFormatted:{
                get(){
                    return this.coupon.code;
                },
                set(value){
                    this.coupon.code = value;
                    this.formatCode();
                }
            },
            productsFiltered(){
                return this.products.filter(item=>{
                    return item.active == true;
                })
            },
            customProductsFiltered(){
                return this.customProducts.filter(item=>{
                    return item.active == true;
                })
            },
            validateTitle(){
                return this.coupon.title !== '' && String(this.coupon.title).length > 0;
            },
            validateCode(){
                return this.coupon.code !== '' && String(this.coupon.code).length > 0;
            },
            validateValue(){
                if(this.coupon.in_percent){
                    return this.coupon.value > 0 && this.coupon.value < 100;
                }

                return this.coupon.value > 0;
            },
            validateForm(){
                return this.validateTitle && this.validateCode && this.validateValue;
            }
        },
        methods:{
            formatCode(){
               this.coupon.code = String(this.coupon.code).trim().replace(/[\s\/]/g, '');
            },
            formatPercent(){
                let couponValue = this.coupon.value;
                if(couponValue > 100){
                    couponValue = 100;
                }
                if(couponValue < 0){
                    couponValue = 0;
                }
                this.coupon.value = couponValue
            },
            checkProduct(product){
                if(this.coupon.products.regular.includes(product.id)){
                    return this.coupon.products.regular = this.coupon.products.regular.filter(item => item !== product.id);
                }

                this.coupon.products.regular.push(product.id);
            },
            checkCustomProduct(product){
                if(this.coupon.products.custom.includes(product.id)){
                    return this.coupon.products.custom = this.coupon.products.custom.filter(item => item !== product.id);
                }

                this.coupon.products.custom.push(product.id);
            },
            submitCoupon(){
                if(!this.validateForm){
                    return;
                }

                if(this.isCreating){
                    return this.createCoupon();
                }
                this.updateCoupon();
            },

            createCoupon(){
                this.isSaving = true;

                axios.post(`/api/admin/coupon`, this.coupon).then(response => {
                    this.$router.replace({
                        name:'coupon.index',
                    });
                    this.isSaving = false;
                });
            },
            updateCoupon(){
                this.isSaving = true;

                axios.put(`/api/admin/coupon/${this.$route.params.coupon}`, this.coupon).then(response => {
                    this.$router.replace({
                        name:'coupon.index',
                    });
                    this.isSaving = false;
                });
            }
        },
        created() {
            this.$store.dispatch('getProducts');
            this.$store.dispatch('getCustomProducts');
            this.$store.dispatch('getCoupons');
            if(!this.isCreating){
                axios.get(`/api/admin/coupon/${this.$route.params.coupon}`).then(response => {
                    this.coupon = response.data.data;
                });
            }
        }
    }
</script>

<style scoped>

</style>
